export default __webpack_public_path__ + "static/media/onboarding_upperdoodads.4cd9a865.png";